
import './App.css';
import Footer from './pages/Footer';
import Banner from './pages/Banner';
import Navbar from './pages/Navbar';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import WhyChooseUs from './pages/why-choose';
import ScrollToTop from './pages/Scrolltotop';


function App() {
  return (
    
    <div className="App">
        <Navbar />
    <section id="home" style={{ }}>
      <Banner/>
      </section>
      <section id="about" className=''>
      <About />
      </section>
      {/* <section id="solutions" className=''>
      <Solutions />
      </section> */}
     < section id="services" className=''>
     <Services/>
     </section>
     < section className=''>
     <Projects/>
     </section>
      <section id="why" className=''>
      <WhyChooseUs />
      </section>
      {/* <section id="partner" className=''>
      <Partner />
      </section> */}
      {/* <section id="tech" className='py-md-5'>
      <Technologies/>
      </section> */}
      <section id="footer" style={{ }} className=''>
      <Footer/>
      </section>
      <ScrollToTop/>
    </div>
  );
}

export default App;
